import React from 'react'
import Table from 'antd/lib/table'
import 'antd/lib/table/style/index.css'

import { ConfirmButton } from '~/components'

import { cancelOrder } from '~/firebase.actions'
import { SYMBOLS } from '~/utils'
import { OrderedProduct, OrderObject } from '~/types'

import './style.css'


export default class Orders extends React.Component<{orders: OrderObject[]}> {

  onCancelOrder = (ev: React.SyntheticEvent<HTMLButtonElement>) => cancelOrder(ev.currentTarget.dataset.value!)

  renderOrders = () => (
    <Table
      className="walletTable" size="small"
      dataSource={this.props.orders}
      rowKey="timestamp"
      expandedRowRender={Orders.renderExpandedRow}
      pagination={false}
    >
      {/* <Table.Column render={v => console.debug('v', v) || undefined}/> */}
      <Table.Column key="paymentMethod" dataIndex="paymentMethod" title="Payment method" width={130}/>
      <Table.Column key="priceEUR" dataIndex="priceEUR" title="Price" render={v => SYMBOLS.sformat(v, 'EUR')} width={360}/>
      <Table.Column
        key="timestamp" title="Order date" dataIndex="timestamp" render={this.renderWalletDate} width={140}
      />
      <Table.Column key="actions" title="Actions" width={110} render={(row) => (
        <>
          <ConfirmButton size="small" ghost type="danger" className="ant-btn-dashed"
            onClick={this.onCancelOrder} data-value={row.key}>Cancel</ConfirmButton>
        </>
      )}/>
    </Table>
  )

  static renderExpandedRow = (superRow: OrderObject) => (
    <Table
      className="walletTable" size="small"
      showHeader={false}
      dataSource={[
        {row: 'Basket', expandedRowRender: () => Orders.renderBasket(superRow.basket)},
        {row: 'Payment Method', expandedRowRender: () => Orders.renderPaymentMethod(superRow)},
      ]}
      rowKey="row"
      expandedRowRender={row => row.expandedRowRender()}
      pagination={false}
    >
      <Table.Column key="row" dataIndex="row"/>
    </Table>
  )

  static renderBasket = (basket: OrderedProduct[]) => (
    <Table
      className="basketTable" size="small"
      dataSource={basket}
      pagination={false}
      rowKey={() => Math.random().toString()}
    >
      <Table.Column key="description" title="Description" width={610} render={(row: OrderedProduct) => {
        const isntVariableProduct = Number(row.productId) > 0
        const description = isntVariableProduct ? row.description : `${row.computingPower} MH/s @ €${(row.price / row.computingPower).toFixed(2)}`
        return (
          <>
            <h3>{row.name}</h3>
            <p>{description}</p>
          </>
        )
      }}/>
      <Table.Column width={110} key="price" title="Price" render={(row: OrderedProduct) => '€' + row.price}/>
    </Table>
  )

  static renderPaymentMethod = (row: OrderObject) => (
    <article className="_basketWrapper">
      {
        row.paymentMethod === 'EUR'
          ? Orders.renderBankRecipient(row.bankPayment)
          : Orders.renderCryptoRecipient(row)
      }
    </article>
  )

  static renderBankRecipient({referenceSymbol, variableSymbol}: OrderObject['bankPayment']) {
    return (
      <>
        <input id="bankSwitch" type="checkbox" style={{display: 'none'}}/>
        <label htmlFor="bankSwitch" className="bankSwitch">
          <span className="domestic">Domestic Czech Transfer </span>
          <span className="switch"/>
          <span className="international">International Bank Transfer</span>
        </label>

        {/* Domestic transfer */}

        <div className="ant-table ant-table-small domestic">
          <div className="ant-table-content">
            <div className="ant-table-body">
              <table>
                <colgroup>
                  <col style={{width: 140, minWidth: 140}}/>
                  <col style={{width: 250, minWidth: 250}}/>
                </colgroup>
                <tbody className="ant-table-tbody">
                  <tr className="ant-table-row">
                    <td><span>Message for Recipient</span></td>
                    <td><span className="focus">{referenceSymbol}</span><br/><span className="danger">This must be included exactly for your deposit to succeed</span></td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Variable Symbol</td>
                    <td><span className="focus">{variableSymbol}</span><br/><span className="danger">This must be included exactly for your deposit to succeed</span></td>
                  </tr>
                  <tr className="ant-table-row">
                    <td><span>{"Recipient's bank number"}</span></td>
                    <td>86-2737760257/0100</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Recipient Name</td>
                    <td>Vítězslav Ackermann Ferko</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="ant-table-footer">
              <table>
                <colgroup>
                  <col style={{width: 390 - 32, minWidth: 390 - 32}}/>
                </colgroup>
                <tfoot>
                  <tr>
                    <td>
                      {"Deposits can take up to 2 business days depending on the payment provider. We'll send you an email as soon as it arrives."}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        {/* International transfer */}

        <div className="ant-table ant-table-small international">
          <div className="ant-table-content">
            <div className="ant-table-body">
              <table>
                <colgroup>
                  <col style={{width: 140, minWidth: 140}}/>
                  <col style={{width: 250, minWidth: 250}}/>
                </colgroup>
                <tbody className="ant-table-tbody">
                  <tr className="ant-table-row">
                    <td>Reference Number</td>
                    <td><span className="focus">{referenceSymbol}</span><br/><span className="danger">This must be included exactly for your deposit to succeed</span></td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>{"Recipient's IBAN"}</td>
                    <td>EE123456789012345678</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Recipient Name</td>
                    <td>Future Mining s.r.o.</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Bank Country</td>
                    <td>Czech Republic</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Bank Name</td>
                    <td>Some Bank</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Bank Address</td>
                    <td><span>Brnenska 1, Brno 61800, Czech Republic</span></td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>Recipient Address</td>
                    <td>6th Floor, Tuřanka 1519/115a, 627 00 Brno-Slatina, Czech Republic</td>
                  </tr>
                  <tr className="ant-table-row">
                    <td>SWIFT / BIC</td>
                    <td>XYZ123</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="ant-table-footer">
              <table>
                <colgroup>
                  <col style={{width: 390 - 32, minWidth: 390 - 32}}/>
                </colgroup>
                <tfoot>
                  <tr>
                    <td>
                      {"Deposits can take up to 2 business days depending on the payment provider. We'll send you an email as soon as it arrives."}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </>
    )
  }

  static renderCryptoRecipient = ({paymentMethod, cryptoPayment: {address, amount}}: OrderObject) => (
    <div className="ant-table ant-table-small domestic">
      <div className="ant-table-content">
        <div className="ant-table-body">
          <table>
            <colgroup>
              <col style={{width: 140, minWidth: 140}}/>
              <col style={{width: 250, minWidth: 250}}/>
            </colgroup>
            <tbody className="ant-table-tbody">
              <tr className="ant-table-row">
                <td>Address</td>
                <td><span className="focus">{address}</span><br/><span className="danger">{"This is a one time address for this payment. Don't use it for other payments."}</span></td>
              </tr>
              <tr className="ant-table-row">
                <td>Amount</td>
                <td>{amount}</td>
              </tr>
              <tr className="ant-table-row"><td>Currency</td><td>{paymentMethod}</td></tr>
            </tbody>
          </table>
        </div>
        <div className="ant-table-footer">
          <table>
            <colgroup>
              <col style={{width: 390 - 32, minWidth: 390 - 32}}/>
            </colgroup>
            <tfoot>
              <tr>
                <td>
                  {"We'll send you an email as soon as the transaction is confirmed by the network."}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  )

  renderWalletDate = (date: number) => new Date(date).toLocaleDateString(undefined, {weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})

  render() {
    return (
      <div className="isoLayoutContentWrapper sc-fjdhpX cKswoM ordersWrapper" style={{height: '100%'}}>
        <main className="sc-iRbamj gXBuxZ">

          <section>
            <h2 className="isoComponentTitle sc-jzJRlG kviPuT">Pending orders</h2>

            <this.renderOrders/>
          </section>

        </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Orders/index.tsx